const ADD_TO_CART_COOKIE = 'ml_search-nordic_add-to-cart-post-login';

module.exports = {
  ADD_TO_CART_COOKIE,
};
